import React from "react";
import ReportButton from "../../applicationUi/components/ReportButton"; // Adjust the path if necessary
import {
  DocumentIcon,
  CreditCardIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";

function ReportList({ onSelectReport }) {
  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      {/* Developer Test Section */}
      <section id="test" className="bg-yellow-50 border border-yellow-200 p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-yellow-800 mb-3">🧪 Developer Tests</h2>
        <p className="text-yellow-700 mb-4">Testing tools for PDF pagination, layout validation, and database integrity checks.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="PDF Pagination Test"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("PDF Pagination Test")}
            className="bg-yellow-100 hover:bg-yellow-200 border-yellow-300 text-yellow-800"
          />
          <ReportButton
            reportName="Orphaned Uploads Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Orphaned Uploads Report")}
            className="bg-yellow-100 hover:bg-yellow-200 border-yellow-300 text-yellow-800"
          />
        </div>
      </section>

      <section id="revenue" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Revenue</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic revenue.</p>
        <ReportButton
          reportName="Revenue Report"
          icon={<DocumentIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Revenue Report")}
        />
      </section>

      <section id="invoices" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Invoices</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to invoices.</p>
        <ReportButton
          reportName="Invoice Report"
          icon={<DocumentIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Invoice Report")}
        />
      </section>

      <section id="clients" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clients</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic clients.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clients Report")}
          />
          <ReportButton
            reportName="Active Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Active Clients Report")}
          />
          <ReportButton
            reportName="Clients Dropoff Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clients Dropoff Report")}
          />
          <ReportButton
            reportName="Block Therapy Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Block Therapy Report")}
          />
          <ReportButton
            reportName="Client Statement"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Client Statement")}
          />
          <ReportButton
            reportName="Client History Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Client History Report")}
          />
          <ReportButton
            reportName="Recall Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Recall Clients Report")}
          />
        </div>
      </section>

      <section id="clinicians" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clinicians</h2>
        <p className="text-gray-600 mb-4">This section includes various clinician-related reports.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="Clinician Schedule Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Schedule Report")}
          />
          <ReportButton
            reportName="Clinician Payroll Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Payroll Report")}
          />
          <ReportButton
            reportName="Clinician Hours Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Hours Report")}
          />
          <ReportButton
            reportName="Clinician Availability Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Availability Report")}
          />
          <ReportButton
            reportName="Clinician Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Clients Report")}
          />
          <ReportButton
            reportName="Cancellation Tracking Report"
            icon={<ChartBarIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Cancellation Tracking Report")}
          />
        </div>
      </section>

      <section id="collections" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Collections</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic collections.</p>
        <ReportButton
          reportName="Collections Report"
          icon={<CreditCardIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Collections Report")}
        />
      </section>

      <section id="quickbooks" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">QuickBooks</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to QuickBooks integration and posting status.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="QuickBooks Invoices Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("QuickBooks Invoices Report")}
          />
          <ReportButton
            reportName="QuickBooks Payments Report"
            icon={<CreditCardIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("QuickBooks Payments Report")}
          />
          <ReportButton
            reportName="QuickBooks Audit Report"
            icon={<ChartBarIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("QuickBooks Audit Report")}
          />
        </div>
      </section>

      <section
        id="clinic-performance"
        className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clinic Performance</h2>
        <p className="text-gray-600 mb-4">
          This section includes reports related to overall clinic performance.
        </p>
        <ReportButton
          reportName="Clinic Performance Report"
          icon={<ChartBarIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Clinic Performance Report")}
        />
      </section>

      <section id="journeys" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Client Journeys</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to client journey progress and analytics.</p>
        <ReportButton
          reportName="Client Journey Progress Report"
          icon={<ChartBarIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Client Journey Progress Report")}
        />
      </section>

      <section id="payroll" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Payroll</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinician payroll and compensation tracking.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="Payroll Summary Report"
            icon={<CreditCardIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Payroll Summary Report")}
          />
          <ReportButton
            reportName="Payroll Audit Report"
            icon={<ChartBarIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Payroll Audit Report")}
          />
        </div>
      </section>
    </div>
  );
}

export default ReportList;
